import React from "react";

// Marca la página como "cargando" al montarse (props.onLoading) y la libera
// cuando terminó de traer todos sus datos (props.onDoneLoading).
//
// Garantiza un único onDoneLoading por cada onLoading: si la página se
// desmonta antes de que las consultas terminen, el ticket se libera igual
// para que el preloader no quede colgado.
//
// Uso:
//   const doneLoading = usePageLoading(props);
//   ...
//   const fetchData = async () => {
//     try { ... } catch {} finally { doneLoading(); }
//   };
export function usePageLoading({ onLoading, onDoneLoading } = {}) {
  const pending = React.useRef(false);
  const callbacks = React.useRef({ onLoading, onDoneLoading });
  callbacks.current = { onLoading, onDoneLoading };

  const doneLoading = React.useCallback(() => {
    if (!pending.current) return;
    pending.current = false;
    if (callbacks.current.onDoneLoading) callbacks.current.onDoneLoading();
  }, []);

  React.useEffect(() => {
    pending.current = true;
    if (callbacks.current.onLoading) callbacks.current.onLoading();
    return doneLoading;
  }, [doneLoading]);

  return doneLoading;
}

export default usePageLoading;
